
import { InjectionToken } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MenuItem } from './layout-models';

export const SIDENAV_CONFIG = new InjectionToken<MenuItem>('data_sidenav');


export const MENU_ITEMS: MenuItem[] = environment.menu;
